export const delay = (ms: number): Promise<void> => {
    return new Promise((resolve) => setTimeout(resolve, ms));
};

export function resolveEnv(name: string): any {
    return (window as any)?.__env__?.[name] || process.env[name];
}
